import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import BackChevronIconSvg from '../../../assets/icons/icon-back-chevron.svg?react';
import { BaseButton } from '../../../shared/ui';

type MyPageSettingsSecurityScreenProps = {
  onOpenPin: () => void;
};

const Screen = styled.section.attrs({
  'data-ui': 'my-page-settings-security-screen',
})`
  padding-top: ${({ theme }) => theme.scale.px(6)};
`;

const Card = styled.div`
  border-radius: ${({ theme }) => theme.scale.px(10)};
  background: ${({ theme }) => theme.colors.surface.subtle};
  overflow: hidden;
`;

const RowButton = styled(BaseButton)`
  width: 100%;
  box-sizing: border-box;
  min-height: ${({ theme }) => theme.scale.px(48)};
  padding: ${({ theme }) => theme.scale.px(15)}
    ${({ theme }) => theme.scale.px(22)};
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: ${({ theme }) => theme.scale.px(12)};
  text-align: left;
`;

const Label = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.scale.px(15)};
  line-height: ${({ theme }) => theme.scale.px(18)};
`;

const ChevronIcon = styled(BackChevronIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(6)};
  height: ${({ theme }) => theme.scale.px(11)};
  color: rgba(0, 0, 0, 0.6);
  transform: rotate(180deg);

  & path {
    stroke: currentColor;
  }
`;

export function MyPageSettingsSecurityScreen({
  onOpenPin,
}: MyPageSettingsSecurityScreenProps) {
  const { t } = useTranslation();

  return (
    <Screen>
      <Card>
        <RowButton type="button" onClick={onOpenPin}>
          <Label>{t('myPageSettings.security.changePin')}</Label>
          <ChevronIcon />
        </RowButton>
      </Card>
    </Screen>
  );
}
